import {
  OceanOfferFace,
  type OceanOfferType,
} from "../OceanOfferFace";
import { TiltedOfferCard } from "../TiltedOfferCard";
import styles from "./OceanOfferCard.module.scss";

interface OceanOfferCardProps {
  type: OceanOfferType;
  amount: number;
  numberOfRates: number;
  trackingId: string;
  onDetailsClick: () => void;
}

const CONTENT: Record<
  OceanOfferType,
  { title: string; description: [string, string] }
> = {
  "credit-line": {
    title: "Linie de credit",
    description: ["Rambursezi oricând.", "Dobândă doar pe suma utilizată."],
  },
  installment: {
    title: "Credit în rate",
    description: ["Rate lunare egale.", "Durată prestabilită."],
  },
};

// A partner offer, its card tilted at the side.
export function OceanOfferCard({
  type,
  amount,
  numberOfRates,
  trackingId,
  onDetailsClick,
}: OceanOfferCardProps) {
  return (
    <TiltedOfferCard
      {...CONTENT[type]}
      glow={type}
      face={
        <OceanOfferFace
          type={type}
          amount={amount}
          numberOfRates={numberOfRates}
          className={styles.face}
        />
      }
      faceVariant="ocean"
      trackingId={trackingId}
      onDetailsClick={onDetailsClick}
    />
  );
}
